import React from "react";
import {Link} from "gatsby";
import {Container, Row, Col, Button} from "react-bootstrap";

import imgC from "../../../assets/image/scheduling-software/handle-last-minute changes.png";

const Content = () => {
  return (
    <>
      {/* <!-- Content Area --> */}
      <div className="content-section pt-12 pb-13 pt-lg-21 pb-lg-22 ">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col xs="10" lg="6" className="pr-lg-9">
              <div className="content-text">
                <h2 className="gr-text-4 mb-8">
                  Handle last-minute changes easily
                </h2>
                <p className="gr-text-8 pr-4 mb-11">
                  <ul className="list-unstyled">
                    <li className="py-4">Employees can swap shifts in unexpected situations, or choose open shifts if they want more work hours.</li>
                    <li className="py-4">Managers can deny or approve the requests, or turn on the auto-approve feature.</li>
                    <li className="py-4">Find shift replacements for absences right on Camelo without having to ring around.</li>
                  </ul>
                </p>
              </div>
            </Col>
            <Col sm="10" lg="6" className="pl-12 mt-10 mt-lg-0">
              <div
                className="content-img img-group-1"
                data-aos="fade-left"
                data-aos-duration="750"
              >
                <img className="img-fluid" src={imgC} alt="Handle last-minute changes easily" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Content;
